import { render, staticRenderFns } from "./NewEvents.vue?vue&type=template&id=e7d2e8a6"
import script from "./NewEvents.vue?vue&type=script&lang=js"
export * from "./NewEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports